import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../services/gtag.service';
import { LANGUAGE_MAPPINGS } from '../settings/language-mapping';

@Component({
  selector: 'app-level',
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule],
  templateUrl: './level.page.html',
  styleUrls: ['./level.page.scss'],
})
export class LevelPage implements OnInit {
  nativeLanguage = '';
  targetLanguage = '';
  targetLanguageName = '';
  selectedLevel = 1;
  
  levels = [
    { value: 1, label: 'LEVEL.BEGINNER' },
    { value: 2, label: 'LEVEL.INTERMEDIATE' },
    { value: 3, label: 'LEVEL.ADVANCED' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {
    // Get the passed state from navigation (fallback)
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.nativeLanguage = navigation.extras.state['nativeLanguage'];
      this.targetLanguage = navigation.extras.state['targetLanguage'];
    }
  }

  ngOnInit() {
    document.title = 'Choose Level';
    
    // Check for query parameters first (more reliable)
    this.route.queryParams.subscribe(params => {
      if (params['native'] && params['target']) {
        this.nativeLanguage = params['native'];
        this.targetLanguage = params['target'];
      }
      
      // If we still don't have languages, redirect back to beginning
      if (!this.nativeLanguage || !this.targetLanguage) {
        this.router.navigate(['/beginning']);
        return;
      }
      
      // Set the app language to native language
      this.translate.use(this.nativeLanguage);
      
      // Get target language name in native language
      const availableLanguages = LANGUAGE_MAPPINGS[this.nativeLanguage] || [];
      const targetLang = availableLanguages.find(lang => lang.code === this.targetLanguage);
      this.targetLanguageName = targetLang?.name || this.targetLanguage;
    });
  }

  goToPreferences() {
    // Just navigate to setup page with language data
    this.router.navigate(['/setup'], {
      state: {
        languageData: {
          nativeLanguage: this.nativeLanguage,
          targetLanguage: this.targetLanguage,
          selectedLevel: this.selectedLevel
        }
      }
    });
  }

  goBack() {
    this.router.navigate(['/beginning'], {
      queryParams: {
        lang: this.nativeLanguage
      }
    });
  }
}